import { releaseNewsActionTypes as actionTypes } from '../ActionTypes/releaseNewsActionTypes';
import commonActions from './commonActions';
import forms from '../Constants/forms';
import { apiThunk } from '../Utils/apiThunk';
import type { AppDispatch } from '../Store/types';
import type { paths } from '../Types/api';

type ReleaseNewsItem = paths['/api/ReleaseNews/Get/{id}']['get']['responses'][200]['content']['application/json'];
type ReleaseNewsList = paths['/api/Settings/GetAllReleaseNews']['get']['responses'][200]['content']['application/json'];

const LOADING_KEY = 'releaseNews';

const finishEditing = (dispatch: AppDispatch, successMessage: string) => {
    dispatch(commonActions.cancelFormEditing(forms.releaseNewsForm));
    dispatch(commonActions.showSuccess(successMessage));
    return true;
};

const post = (url: string, item: ReleaseNewsItem | null, successMessage: string) => (dispatch: AppDispatch) =>
    dispatch(
        apiThunk<unknown>(url, {
            loadingKey: LOADING_KEY,
            init: { method: 'POST', body: item === null ? undefined : JSON.stringify(item) },
            rethrow: true,
        })
    )
        .then(() => finishEditing(dispatch, successMessage))
        .catch(() => false);

const releaseNewsActions = {
    getAll() {
        return (dispatch: AppDispatch) =>
            dispatch(apiThunk<ReleaseNewsList>('/api/Settings/GetAllReleaseNews', { loadingKey: LOADING_KEY })).then((data) => {
                if (data) dispatch({ type: actionTypes.STORE_RELEASE_NEWS, data });
            });
    },

    get(id: string) {
        return (dispatch: AppDispatch) =>
            dispatch(apiThunk<ReleaseNewsItem>(`/api/ReleaseNews/Get/${id}`, { loadingKey: LOADING_KEY })).then((data) => {
                if (data) dispatch(commonActions.startFormEditing(forms.releaseNewsForm, data));
            });
    },

    startNew(item: ReleaseNewsItem) {
        return commonActions.startFormEditing(forms.releaseNewsForm, item);
    },

    create(item: ReleaseNewsItem) {
        return post('/api/Settings/CreateReleaseNews', item, 'Release news item has been added!');
    },

    update(item: ReleaseNewsItem) {
        return post('/api/Settings/UpdateReleaseNews', item, 'Release news item has been updated!');
    },

    remove(id: string) {
        return post(`/api/Settings/DeleteReleaseNews/${id}`, null, 'Release news item has been deleted');
    },
};

export default releaseNewsActions;
